export default __webpack_public_path__ + "static/media/SWT0090.34I-30175_-17437_0.89ca8753.jpg";